var map = {
	"./chameleon-theme-az/lib/styleguide/tokens.ios.json": "6x+4",
	"./chameleon-theme-beltel/lib/styleguide/tokens.ios.json": "T10N",
	"./chameleon-theme-co/lib/styleguide/tokens.ios.json": "aomW",
	"./chameleon-theme-dl/lib/styleguide/tokens.ios.json": "z+IQ",
	"./chameleon-theme-ds/lib/styleguide/tokens.ios.json": "mr0i",
	"./chameleon-theme-ge/lib/styleguide/tokens.ios.json": "bVqv",
	"./chameleon-theme-gva/lib/styleguide/tokens.ios.json": "CYvD",
	"./chameleon-theme-hbvl/lib/styleguide/tokens.ios.json": "swWl",
	"./chameleon-theme-hd/lib/styleguide/tokens.ios.json": "BFqR",
	"./chameleon-theme-hub/lib/styleguide/tokens.ios.json": "eqNx",
	"./chameleon-theme-indo/lib/styleguide/tokens.ios.json": "Uke6",
	"./chameleon-theme-ld/lib/styleguide/tokens.ios.json": "Gqoa",
	"./chameleon-theme-lt/lib/styleguide/tokens.ios.json": "1reT",
	"./chameleon-theme-lw/lib/styleguide/tokens.ios.json": "TSWg",
	"./chameleon-theme-mh/lib/styleguide/tokens.ios.json": "9Aw+",
	"./chameleon-theme-nb-legacy/lib/styleguide/tokens.ios.json": "xVYR",
	"./chameleon-theme-nb/lib/styleguide/tokens.ios.json": "hBbk",
	"./chameleon-theme-nhd/lib/styleguide/tokens.ios.json": "WyJg",
	"./chameleon-theme-sw/lib/styleguide/tokens.ios.json": "ba+P",
	"./chameleon-theme-tc/lib/styleguide/tokens.ios.json": "TDD9",
	"./chameleon-theme-tel/lib/styleguide/tokens.ios.json": "sQnO",
	"./chameleon-theme-vl/lib/styleguide/tokens.ios.json": "rbAf",
	"./chameleon-theme-wl/lib/styleguide/tokens.ios.json": "kcLL",
	"./chameleon-theme-yc/lib/styleguide/tokens.ios.json": "gwNL"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "qhk0";